export const QueryParams = {
  ERROR_CODE: 'errorCode',
  SOURCE_APP: 'app',
} as const;

export type QueryParams = (typeof QueryParams)[keyof typeof QueryParams];
